//flow
import { makeCrudBuilderInitialState } from "seneca-common/utils/apiStates";

import { coursesQueryCrudStateConfig } from "../consts";

const coursesQueryMetaInitialState = makeCrudBuilderInitialState(
  coursesQueryCrudStateConfig
);

export default coursesQueryMetaInitialState;
